/**
 * Created by Ivan on 10.08.2026
 */

Placements.ENTRIES["updateStickersBook2Season"] = {
    priority: -1000,
    type: Placements.FREE_FOCUS_MAIN,

    action: function () {
        cleverapps.stickersBook2.updateSeason();
    }
};

Placements.ENTRIES["stickers2RewardWindow"] = {
    type: Placements.FREE_FOCUS_MAIN | Placements.FREE_FOCUS_OTHER,
    priority: 2,

    filter: function () {
        return cleverapps.stickersBook2.isAvailable() && cleverapps.stickersBook2.newStickers && cleverapps.stickersBook2.newStickers.length > 0;
    },

    action: function () {
        cleverapps.focusManager.display({
            focus: "StickersRewardWindow2",
            action: function (f) {
                new StickersRewardWindow2();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
};

Placements.ENTRIES["stickers2FlyIcon"] = {
    type: Placements.INTERMEDIATE,

    filter: function () {
        return cleverapps.environment.isMainScene() && cleverapps.stickersBook2.isAvailable();
    },

    action: function () {
        cleverapps.eventBus.trigger("stickers2_add_fly_icon");
    }
};
